module.exports = __webpack_public_path__ + "static/media/lv_desk_r.90969654.png";